export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/c239755bda8554c3c2c3a880497b48bd.png";